import { render, staticRenderFns } from "./CragSectorHead.vue?vue&type=template&id=b6eb4ca8"
import script from "./CragSectorHead.vue?vue&type=script&lang=js"
export * from "./CragSectorHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports